<template>
  <div class="panel panel-success shadow">
    <div class="panel-heading">
      <h3 class="panel-title">
        Orientações para retirada de {{ remedio.principio_ativo }}
      </h3>
    </div>
    <div class="panel-body">
      <p class="font-lg orientacao" v-html="getDescricaoOrientacao(remedio)" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CriterioRemedio',
  props: {
    remedio: {
      type: Object,
      required: true
    }
  },
  methods: {
    getDescricaoOrientacao({ orientacao }) {
      const index = orientacao.indexOf(':')
      const title = orientacao.substring(0, index + 1)
      const text = orientacao.substring(index + 1)

      return `<strong>${title}</strong> ${text}`
    }
  }
}
</script>

<style scoped>
.shadow {
  box-shadow: 0px 0px 5px 0px #00302e;
}

p.orientacao {
  color: #00615c;
}
</style>



// WEBPACK FOOTER //
// src/components/CriterioRemedio/index.vue